import { includes } from 'ramda';

import { UNAUTHENTICATED_ROUTS } from 'constants/auth';

const shouldAuthenticate = (pathname) => !includes(pathname, UNAUTHENTICATED_ROUTS);

export default shouldAuthenticate;
